import React from "react";
import { Outlet } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { useTranslation } from "react-i18next";

import Footer from "./common/footer";
import Header from "./common/header_components/header";
import RightSidebar from "./common/right-sidebar";
import Sidebar from "./common/sidebar_components/sidebar";

const App = (props) => {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language?.startsWith("zh") ? zhCN : enUS;
  //  all comented by ahmed this for RTL LTR option

  // const initialState = {
  // 	ltr: true,
  // 	divName: "RTL",
  // };

  // const [side, setSide] = useState(initialState);

  // const ChangeRtl = (divName) => {
  // 	if (divName === "RTL") {
  // 		document.body.classList.add("rtl");
  // 		setSide({ divName: "LTR" });
  // 	} else {
  // 		document.body.classList.remove("rtl");
  // 		setSide({ divName: "RTL" });
  // 	}
  // };
  return (
    <ConfigProvider locale={currentLocale}>
      <div>
        <div className="page-wrapper">
          <Header />
          <div className="page-body-wrapper">
            <Sidebar />
            <RightSidebar />
            <div className="page-body">
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};
export default App;
